import type { FC } from 'react'
import React from 'react'
import { ExitIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ExitIcon'
import classNames from 'classnames'
import { Fading } from '../animations'
import { Button } from '..'
import type { IClosableMessageProps } from './interfaces'
import './сlosableMessage.scss'

const ClosableMessage: FC<IClosableMessageProps> = ({ children, onClose, isVisible, className }) => (
  <Fading isVisible={isVisible}>
    <div className={classNames('closable-message', className)}>
      {children}
      {onClose && (
        <Button className="closable-message__close-button" isUnstyled onClick={onClose} iconProps={{ component: <ExitIcon /> }} />
      )}
    </div>
  </Fading>
)

export default ClosableMessage
